import React, { useEffect, useState } from "react";
import { useOption } from "../../context/OptionContext";
import { CiSearch } from "react-icons/ci";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { FaSpinner } from "react-icons/fa6";
import { useStockName } from "../../context/StockNameContext";
import "./PcrTestPage.css";
const PcrTestPage = () => {
  const {
    fetchBySymbol,
    loading,
    error,
    pcr,
    meta,
    expiries,
    optionData,
    selectedExpiry,
    setSelectedExpiry,
    setExpiry,
    fetchByIndex,
  } = useOption();
  const [searchText, setSearchText] = useState("");
  const [symbol, setSymbol] = useState("");
  const [activeSymbol, setActiveSymbol] = useState("");
  const [lastFetchType, setLastFetchType] = useState(null);
  const [selectDropdown, setSelectDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [contract, setContract] = useState("");
  const { fetchStock, stockData } = useStockName();
  //   const getPlaceholder = () => {
  //     if (window.matchMedia("(max-width: 600px)").matches) {
  //       return "Search";
  //     }
  //     return "Search Symbol";
  //   };
  //   const [placeholder, setPlaceholder] = useState(getPlaceholder());
  const nseIndices = [
    "NIFTY",
    "BANKNIFTY",
    "FINNIFTY",
    "MIDCPNIFTY",
    "NIFTYIT",
    "NIFTYAUTO",
    "NIFTYPHARMA",
    "NIFTYMETAL",
    "NIFTYFMCG",
    "NIFTYREALTY",
    "NIFTYMEDIA",
    "NIFTYENERGY",
  ];

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && searchText.trim()) {
      setSymbol(searchText.trim().toUpperCase());
      const val = searchText.trim().toUpperCase();
      setActiveSymbol(val);
      setLastFetchType("symbol");
      setSearchText("");
      setSelectedIndex("");
      setSelectDropdown(false);
      fetchBySymbol(val);
    }
  };
  const handleIndexSelect = (e) => {
    const indexSymbol = e.target.value;
    console.log("Index Symbol", indexSymbol);
    setContract(indexSymbol);
    if (!indexSymbol) return;

    setSearchText("");
    setSelectedIndex(indexSymbol);
    setActiveSymbol(indexSymbol);
    setLastFetchType("index");

    setSelectDropdown(true);
    fetchByIndex(indexSymbol);
  };

  console.log("Pcr data", pcr);

  const getPCRSentiment = (value) => {
    if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
    if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
    return { label: "Bullish", color: "#22c55e" };
  };

  const getCOIPCRSentiment = (value) => {
    if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
    if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
    return { label: "Bullish", color: "#22c55e" };
  };
  const green = "#22c55e";
  const red = "#ef4444";
  const grey = "#9ca3af";

  const getPCRColor = (v) => {
    if (v < 0.7) return red;
    if (v <= 1) return grey;
    return green;
  };

  const getStrengthColor = (v) => (v >= 0 ? green : red);

  const pcrSentiment = getPCRSentiment(pcr?.value);
  const coiSentiment = getCOIPCRSentiment(pcr?.coiPCR);

  useEffect(() => {
    // Load NIFTY by default on first visit
    if (!activeSymbol && !selectedIndex) {
      const defaultIndex = "NIFTY";

      setContract(defaultIndex);
      setSelectedIndex(defaultIndex);
      setActiveSymbol(defaultIndex);
      setLastFetchType("index");
      setSelectDropdown(true);
      // setSelectedStrike("");

      fetchByIndex(defaultIndex);
    }
  }, [activeSymbol, selectedIndex]);
  useEffect(() => {
    if (lastFetchType === "symbol" && activeSymbol) {
      fetchStock(activeSymbol);
    }
  }, [lastFetchType, activeSymbol]);

  console.log("stock data", stockData);
  const companyName = stockData?.name;
  const sentiment = getPCRSentiment(pcr?.pcr);
  return (
    <>
      <div
        className="option-chain-head"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="select-option dropdown">
          <label>Contracts</label>
          <select onChange={handleIndexSelect} value={selectedIndex}>
            <option value="">Select</option>
            {nseIndices.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <span>OR</span>

        <div className="search-option dropdown">
          <label>Search Symbol</label>

          <div
            className="search-option-input"
            style={{
              borderRadius: "12px",

              display: "flex",
              alignItems: "center",
              padding: "0px 10px",

              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
            }}
          >
            <input
              type="text"
              placeholder="Search Symbol"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={handleKeyDown}
              className="search-option-chain"
              style={{
                padding: "14px 15px",

                borderRadius: "20px",
                border: "none",
                outline: "none",
              }}
            />
            <span style={{ cursor: "pointer" }}>
              <CiSearch />
            </span>
          </div>
        </div>
      </div>
      {loading && (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            // color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      )}
      {!loading && error && (
        <div
          style={{
            marginTop: "20px",
            padding: "14px",
            borderLeft: "5px solid #dc2626",
            background: "#fee2e2",
            color: "#7f1d1d",
            fontWeight: 600,
            borderRadius: "8px",
          }}
        >
          ❌ {error}
        </div>
      )}
      {!loading && pcr && (
        <>
          {/* <div className="pcr-summary-row">

  <div className="pcr-box">
    <div>
      <div className="label">Put OI</div>
      <div className="value red">{pcr.totalPutOI.toLocaleString()}</div>
    </div>

    <div>
      <div className="label">Call OI</div>
      <div className="value green">{pcr.totalCallOI.toLocaleString()}</div>
    </div>

    <div>
      <div className="label">PCR</div>
      <div
        className="chip"
        style={{ borderColor: getPCRColor(pcr.pcr), color: getPCRColor(pcr.pcr) }}
      >
        {pcr.pcr}
      </div>
    </div>
  </div>


  <div className="pcr-box">
    <div>
      <div className="label">Put OI Chg</div>
      <div className="value red">{pcr.putOIChg.toLocaleString()}</div>
    </div>

    <div>
      <div className="label">Call OI Chg</div>
      <div className="value green">{pcr.callOIChg.toLocaleString()}</div>
    </div>

    <div>
      <div className="label">COI PCR</div>
      <div
        className="chip"
        style={{
          borderColor: getPCRColor(pcr.coiPCR),
          color: getPCRColor(pcr.coiPCR),
        }}
      >
        {pcr.coiPCR}
      </div>
    </div>

    <div>
      <div className="label">COI Strength %</div>
      <div
        className="chip"
        style={{
          borderColor: getStrengthColor(pcr.coiStrength),
          color: getStrengthColor(pcr.coiStrength),
        }}
      >
        {pcr.coiStrength} %
      </div>
    </div>
  </div>
</div> */}
          <div className="pcr-test-head">
            <h1>Put Call Ratio for {activeSymbol}</h1>
          </div>

          <div
          //  className="pcr-summary-row"
          >
            <div
              className="grid-1"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                textAlign: "left",
                marginTop: "10px",
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
              }}
            >
              {!selectDropdown && <p>Company Name - {companyName}</p>}
              <p>
                {" "}
                {lastFetchType === "index" ? "Contract" : "Stock Symbol"} - {""}
                {activeSymbol}
              </p>

              <p>
                PCR:{" "}
                <strong style={{ color: getPCRColor(pcr?.pcr) }}>
                  {pcr?.value}
                </strong>
              </p>

              <p>
                Signal:{" "}
                <strong style={{ color: sentiment.color }}>
                  {" "}
                  {sentiment?.label}
                </strong>
              </p>
            </div>
            {/* ================= BOX 1 ================= */}
            <div className="pcr-box">
              <div className="pcr-inner-box box-label">
                <div className="pcr-label">Put OI</div>
                <div className="value red">
                  {pcr.totalPutOI.toLocaleString()}
                </div>
              </div>

              <div className="pcr-inner-box box-label">
                <div className="pcr-label">Call OI</div>
                <div className="value green">
                  {pcr.totalCallOI.toLocaleString()}
                </div>
              </div>

              {/* PCR */}
              <div className="pcr-inner-box">
                <div className="pcr-label">PCR</div>

                {(() => {
                  const sentiment = getPCRSentiment(pcr.pcr);

                  return (
                    <div
                      className="chip sentiment-chip"
                      style={{
                        borderColor: getPCRColor(pcr.pcr),
                        color: getPCRColor(pcr.pcr),
                      }}
                    >
                      {pcr?.value}

                      {/* Hover sentiment */}
                      <span
                        className="sentiment-hover"
                        style={{ color: sentiment.color }}
                      >
                        {sentiment.label}
                      </span>
                    </div>
                  );
                })()}
              </div>
            </div>

            {/* ================= BOX 2 ================= */}
            <div className="pcr-box">
              <div className="pcr-inner-box box-label">
                <div className="pcr-label">Put OI Chg</div>
                <div className="value red">
                  {pcr?.putOIChange?.toLocaleString()}
                </div>
              </div>

              <div className="pcr-inner-box box-label">
                <div className="pcr-label">Call OI Chg</div>
                <div className="value green">
                  {pcr?.callOIChange?.toLocaleString()}
                </div>
              </div>

              <div className="pcr-inner-box">
                <div className="pcr-label">COI PCR</div>

                {(() => {
                  const sentiment = getCOIPCRSentiment(pcr?.coiPCR);

                  return (
                    <div
                      className="chip sentiment-chip"
                      style={{
                        borderColor: getPCRColor(pcr.coiPCR),
                        color: getPCRColor(pcr.coiPCR),
                      }}
                    >
                      {pcr.coiPCR}

                      <span
                        className="sentiment-hover"
                        style={{ color: sentiment.color }}
                      >
                        {sentiment.label}
                      </span>
                    </div>
                  );
                })()}
              </div>

              <div className="pcr-inner-box">
                <div className="pcr-label">COI Strength %</div>
                <div
                  className="chip"
                  style={{
                    borderColor: getStrengthColor(pcr.coiStrength),
                    color: getStrengthColor(pcr.coiStrength),
                    textAlign: "center",
                  }}
                >
                  {pcr.coiStrength} %
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PcrTestPage;
